import appSettings from 'wanderu-config';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';
import GoogleService from 'wanderu-service-google';

import {
    actions,
    namespace,
    reducer,
    selectors,
} from './base';
import {
    actions as googleDataActions,
} from '../../appstate';

const logger = Logger.getLogger('wanderu-ducks-google:fetchPlaceDetails');

function fetch(placeId, sessiontoken) {
    return async (dispatch, getState) => {
        const id = placeId;

        const hasFetched = selectors.selectSuccess(getState(), placeId);
        const isFetching = selectors.selectWorking(getState(), placeId);
        if (hasFetched || isFetching) {
            return;
        }

        dispatch(actions.startWork(id));

        let error;
        let meta;
        try {
            const placeDetails = await GoogleService.getPlaceDetails(placeId, { sessiontoken });
            return dispatch(googleDataActions.setPlaceDetails(placeId, placeDetails));
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('fetch', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });
            error = {
                code: ex.code,
                message: ex.message,
                name: ex.name,
            };
        } finally {
            dispatch(actions.endWork(id, meta, error));
        }
    };
}

const fetchPlaceDetailsAction = {
    fetch,
    ...selectors,
};

export {
    fetchPlaceDetailsAction,
};

export default {
    [namespace]: reducer,
};
